export const REFETCH_INTERVAL_MS = 10_000
export const REPORT_POLL_INTERVAL_MS = 5_000
export const DELIVERY_POLL_INTERVAL_MS = 2_000

// Delay before re-invalidating queries that depend on an async backend cascade
// (Kafka consumer, post-update worker, etc.) finishing after the mutation returns.
export const ASYNC_CASCADE_REFETCH_DELAY_MS = 3_500

export const BULK_MUTATION_CONCURRENCY = 10

// Two characters is a real company search — LG, HP, GE, BP, 3M. The server skips the
// product lookup below 3 chars (its trigram index can't serve a leading wildcard that
// short) but still answers with companies.
export const AUTOCOMPLETE_MIN_SEARCH_LEN = 2

export const DEFAULT_TOP_MODEL_PROVIDERS_LIMIT = 10
